import httpService from '../../routes/httpService';
import { parseConfig } from '../config';
import { logError } from '../log';

export const fetchOptimizelyDatafile = async () => {
  const { OPTIMIZELY_SDK_KEY } = parseConfig() as any;

  if (OPTIMIZELY_SDK_KEY) {
    try {
      const response = await httpService.wrappedFetch(
        `https://cdn.optimizely.com/datafiles/${OPTIMIZELY_SDK_KEY}.json`,
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch datafile: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      logError('Error fetching Optimizely datafile:', error);
    }
  }

  return undefined;
};
